import {PaymentError, PaymentMethodUrls} from '@/features/guest-payments/types'
import {useRootStore} from '@/store'
import {selectSetPaymentMethodUrls} from '@/store/selectors'
import {useMutation} from '@tanstack/react-query'
import {AxiosResponse} from 'axios'
import {renewSubscriptionV3} from '../services/guest.http'
import {SubscriptionsUpdateV3} from '../types'
import {MUTATION_KEYS} from './keys'

export const useRenewSubscriptionV3 = () => {
    const setPaymentMethodUrls = useRootStore(selectSetPaymentMethodUrls)
    return useMutation<AxiosResponse, PaymentError, SubscriptionsUpdateV3>({
        mutationKey: [MUTATION_KEYS.renewSubscriptionV3],
        mutationFn: renewSubscriptionV3,
        onSettled: (_, error) => {
            if (error?.response?.status === 303) setPaymentMethodUrls(error?.response?.data as PaymentMethodUrls)
        }
    })
}
